<template>
  <div>
    <link
      href="http://img.233.com/wx/img/union/study2019/kuang.css?v=20190316"
      rel="stylesheet"
      type="text/css"
    />
    <link
      href="http://img2.233.com/wx/union/pc/fine/category/css/yaoshi.css?v=20190316"
      rel="stylesheet"
      type="text/css"
    />
    <div class="wx-header-cont" id="wx-header-cont">
      <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
      <div class="wx-header-container">
        <div class="fl-box">
          <h1 class="logo">
            <a href="/">
              <img :src="logo" />
            </a>
          </h1>
          <div class="line"></div>
          <div class="wx-subject">
            <h2>执业药师</h2>
            <i class="dropdown-arrow"></i>
            <div class="subject-list">
              <a href="./#/jiankanggls">健康管理师</a>
              <a
                target="_blank"
                href="http://wx.zezhipx.com/channel.aspx?domain=hushi"
                >护士资格</a
              >
            </div>
          </div>
          <div
            class="head-area text-gry6 font14 fl m-t-10"
            style="display: none;"
          >
            当前地区
            <p class="m-l-15 bg-white fr">
              <em class="now-area p-0-20">全国版</em>
              <a href class="more-area p-0-10">更多地区</a>
            </p>
            <div class="area_list">
              <ul>
                <li>
                  <a href="/tegang/guojia/#tgtc">全国</a>
                </li>
                <li>
                  <a href="/tegang/shanxi1/#tgtc">陕西</a>
                </li>
                <li>
                  <a href="/tegang/hebei/#tgtc">河北</a>
                </li>
                <li>
                  <a href="/tegang/henan/">河南</a>
                </li>
                <li>
                  <a href="/tegang/sichuan/#tgtc">四川</a>
                </li>
                <li>
                  <a href="/tegang/jiangxi/#tgtc">江西</a>
                </li>
                <li>
                  <a href="/tegang/yunnan/#tgtc">云南</a>
                </li>
                <li>
                  <a href="/tegang/heilongjiang/#tgtc">黑龙江</a>
                </li>
                <li>
                  <a href="/tegang/chongqing/#tgtc">重庆</a>
                </li>
                <li>
                  <a href="/tegang/hubei/#tgtc">湖北</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="fr-box">
          <!--未登录 -->
          <div class="personal-no" v-if="!isLogin">
            <p>
              <a
                target="_blank"
                :href="'/uc/login?redirecturl=' + href"
                class="red"
                >登录</a
              >|
              <a target="_blank" :href="'/uc/register?redirecturl=' + href"
                >注册</a
              >
            </p>
          </div>
          <div class="personal" v-else>
            <a href="javascript:;" class="pic">
              <img :src="logoSrc" />
              <i class="dropdown-arrow"></i>
            </a>
            <div class="pop-personal">
              <a href="javascript:" @click="loginout()">
                <i class="icon"></i>
                <span class="txt">退出</span>
              </a>
            </div>
          </div>
          <div class="classify">
            <a
              class="classify-list"
              href="/shopping/cart"
              target="_blank"
              title="购课车"
            >
              <p class="icon shopping"></p>
            </a>
          </div>
          <div v-if="kefu.length > 0" class="wx-telephone">
            <p class="txt1">客服热线</p>
            <p class="txt2">{{ kefu }}</p>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!--banner-->
    <div class="bg-black">
      <!--01banner-->
      <Banner imgUrl="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/banner01.jpg"></Banner>
      <!--01banner 结束-->
      <!---02试听区域--->
      <div class="video clearfix">
        <div class="video-layout">
          <div class="subject-tabBox clearfix">
            <ul class="sub-tabL clearfix">
              <li
                class="line"
                @click="changeCourseIndex(i)"
                v-for="(v, i) in courses.slice(0, 4)"
                :key="i"
              >
                <a
                  href="javascript: void(0)"
                  :class="i == courseIndex ? 'hover' : ''"
                  >{{ v.name }}</a
                >
              </li>
            </ul>
            <div
              class="Rselect-box"
              @mouseover="changeIsHoverCourse(true)"
              @mouseout="changeIsHoverCourse(false)"
            >
              <p class="subject-select currt clearfix">
                <span class="txt">选择其它科目</span>
                <i class="ico"></i>
              </p>
              <div class="sub-sel-list" v-show="isHoverCourse">
                <ul>
                  <li v-for="(v, i) in courses.slice(4)" :key="i">
                    <a
                      @click="changeCourseIndex(i + 4)"
                      style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
                      href="javascript: void(0)"
                      >{{ v.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <myvideo
            :isLogin="isLogin"
            :allLoginPlayFlag="allLoginPlayFlag"
            :unionId="unionId"
            :classEname="'yaoshi'"
            :logo="logo"
            :myClassId="courses[courseIndex].myClassId"
          ></myvideo>
        </div>
        <div class="video-bottom"></div>
      </div>
      <!---02试听区域END--->
    </div>

    <!--03原高级平台班级对比-->
    <banjiduibi :calssName="'执业药师'" :classEName="'yaoshi'"></banjiduibi>
    <!--03原高级平台班级对比 end-->
    <!--04全部班级表格-->
    <quanbubanji :classEname="'yaoshi'"></quanbubanji>
    <!--04全部班级表格 end-->

    <!--06套用官网内容  开始------------->

    <!--考情分析-->
    <div class="space-title" id="xzjd">
      <div class="space-title">
        <div class="model-title">
          <h3>
            <span class="model-title-span-image">3</span>
            <strong>考情分析</strong>
            <br />改革后考试难度增大，抢先拿证才是王道
          </h3>
        </div>
        <br clear="all" />
      </div>

      <div class="kqfx_box clearfix">
        <div class="bkxz-nr-all clearfix">
          <div class="kqfx_model">
            <div class="kqfx_title">考情一</div>
            <div class="kq_all">
              <div class="kqfx_de_title">
                <i class="kqfx_r"></i>
                <h2>中专2020年可报考</h2>
              </div>

              <div class="kqfx_nr">
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>中专学历人员2020年12月31日前可报名参加考试。</p>
                </div>
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>今年，还有一次报考机会。</p>
                </div>
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>须今年内4科全过，则成绩无效。</p>
                </div>
              </div>
            </div>
          </div>

          <div class="kqfx_model">
            <div class="kqfx_title_01">考情二</div>
            <div class="kq_all">
              <div class="kqfx_de_title">
                <i class="kqfx_r"></i>
                <h2>2020年教材将大改</h2>
              </div>

              <div class="kqfx_nr">
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>执业药师2020年教材预计大变。</p>
                </div>
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>改革过渡还剩一年难度还会增加。</p>
                </div>
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>打好基础至关重要，自学通过机率降低。</p>
                </div>
              </div>
            </div>
          </div>

          <div class="kqfx_model_01">
            <div class="kqfx_title_02">考情三</div>
            <div class="kq_all">
              <div class="kqfx_de_title">
                <i class="kqfx_r"></i>
                <h2>考试难度将大增</h2>
              </div>

              <div class="kqfx_nr">
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>2019年法规成为考证的“拦路虎”。</p>
                </div>
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>各科考题灵活性和综合性逐渐加强。</p>
                </div>
                <div class="kqfx_nr_dl">
                  <i class="kqfx_nr_zs"></i>
                  <p>材料阅读量也会持续加大。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!---考情分析  end--->
    </div>
    <!--考情分析end-->
    <!-- 行业前景 -->
    <div class="body-common body-model-b">
      <div class="body-center">
        <!--02行业前景-->
        <div class="space-title" id="hyqj">
          <div class="model-title bdtitle-black">
            <h3>
              <span class="model-title-span-image">4</span>
              <strong>行业前景</strong>
              <br />高需求+高薪资=高含金量
            </h3>
          </div>
          <br clear="all" />
        </div>

        <div class="hyqj-all">
          <span class="hyqj-line hj-line-gps"></span>
          <span class="hyqj-line hj-line-gps2"></span>

          <ul class="clearfix">
            <li>
              <i class="hyqj-img-1"></i>
              <div class="hyqj-text">
                <h4>高需求</h4>
                <p>
                  目前国内医药从业人员高达130万，但持证者不足一半，市场对持证执业药师需求巨大。
                </p>
              </div>
            </li>
            <li>
              <i class="hyqj-img-2"></i>

              <div class="hyqj-text">
                <h4>高薪资</h4>
                <p>
                  国内执业药师平均工资起底5000左右，一线城市资深药师薪资高达8500~10000元，且上升空间大。
                </p>
              </div>
            </li>
            <li>
              <i class="hyqj-img-3"></i>
              <div class="hyqj-text">
                <h4>高含金量</h4>
                <p>
                  医药体制改革规定，所有从事医药类工作者必须持证上岗，证书已成为市场刚需，含金量大幅度提升。
                </p>
              </div>
            </li>
          </ul>
          <a @click="scroll(880)" class="bkxz-btn_01">持证上岗，挑战高薪</a>
        </div>

        <!--02行业前景END-->

        <!-- 03教学升级-->
        <div class="space-title" id="jxsj">
          <div class="model-title bdtitle-black">
            <h3>
              <span class="model-title-span-image">5</span>
              <strong>教学升级</strong>
              <br />课程历经20+次迭代，畅享更优质学习体验
            </h3>
          </div>
          <br clear="all" />
        </div>

        <div class="wx-mia clearfix">
          <div class="bkgl-list-box">
            <dl class="bkgl-bt">
              <dd>
                <span>升级一</span>
              </dd>
              <dd>
                <span>升级二</span>
              </dd>
              <dd>
                <span>升级三</span>
              </dd>
            </dl>
            <div class="bkgl-line"></div>
            <ul class="clearfix">
              <li class="bkgl-bg">
                <div class="jxsj-model-1">
                  <h3>
                    考点繁杂，
                    <i class="jxsj-zd">无法自行汇总</i>？
                  </h3>
                </div>

                <i class="jxsj-model-2"></i>

                <div class="jxsj-model-3">
                  <div class="jxsj-de-title">
                    <i class="jxss-r"></i>
                    <h2>《教材精讲班》课程讲义</h2>
                  </div>

                  <div class="jxsj-centent claearfix">
                    <div class="jxsj-paragraph claearfix">
                      <i class="jxsj-icon">1</i>
                      <span class="jxsj-wz">
                        《教材精讲班》课程讲义由
                        <i class="jxsj-zd-01">授课老师</i
                        >编制，汇总各科核心考点，方便随手携带学习。
                      </span>
                    </div>
                    <div class="jxsj-paragraph claearfix">
                      <i class="jxsj-icon">2</i>
                      <span class="jxsj-wz">
                        退费班、取证班
                        <i class="jxsj-zd-01">专项配套</i
                        >，包邮到家，畅享一站式学习。
                      </span>
                    </div>
                  </div>

                  <b class="jxsj-img-commn jjimg-1"></b>
                  <p>
                    <span class="text-bold">突破点：</span
                    >课程+讲义配套，学习更高效。
                  </p>
                </div>
              </li>

              <li class="bkgl-bg">
                <div class="jxsj-model-1">
                  <h3>
                    考前冲刺，
                    <i class="jxsj-zd">提分太难</i>？
                  </h3>
                </div>

                <i class="jxsj-model-2"></i>

                <div class="jxsj-model-3">
                  <div class="jxsj-de-title">
                    <i class="jxss-r"></i>
                    <h2>考题突击班</h2>
                  </div>

                  <div class="jxsj-centent claearfix">
                    <div class="jxsj-paragraph claearfix">
                      <i class="jxsj-icon">1</i>
                      <span class="jxsj-wz">
                        授课老师详解
                        <i class="jxsj-zd-01">2套突击卷</i
                        >，预测考点，快速提分。
                      </span>
                    </div>
                    <div class="jxsj-paragraph claearfix">
                      <i class="jxsj-icon">2</i>
                      <span class="jxsj-wz">
                        在听课前，考生可
                        <i class="jxsj-zd-01">全真模拟测试</i>，查漏补缺。
                      </span>
                    </div>
                  </div>

                  <b class="jxsj-img-commn jjimg-2"></b>
                  <p>
                    <span class="text-bold">突破点：</span
                    >每科2套点题卷，预测考点。
                  </p>
                </div>
              </li>

              <li class="bkgl-bg">
                <div class="jxsj-model-1">
                  <h3><i class="jxsj-zd">自律性差</i>，需要监督学习？</h3>
                </div>

                <i class="jxsj-model-2"></i>

                <div class="jxsj-model-3">
                  <div class="jxsj-de-title">
                    <i class="jxss-r"></i>
                    <h2>30人小班管理</h2>
                  </div>

                  <div class="jxsj-centent claearfix">
                    <div class="jxsj-paragraph claearfix">
                      <i class="jxsj-icon">1</i>
                      <span class="jxsj-wz">
                        退费班
                        <i class="jxsj-zd-01">30人小班管理</i
                        >，和考友一起并肩作战。
                      </span>
                    </div>
                    <div class="jxsj-paragraph claearfix">
                      <i class="jxsj-icon">2</i>
                      <span class="jxsj-wz">
                        享班主任督学，
                        <i class="jxsj-zd-01">助教实时答疑</i
                        >，班级排名和阶段学习总结等服务。
                      </span>
                    </div>
                  </div>

                  <b class="jxsj-img-commn jjimg-3"></b>
                  <p>
                    <span class="text-bold">说明：</span
                    >退费班考后上线，如有需要，请在网校app购买。
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 03教学升级END-->
      </div>
    </div>
    <!-- 行业前景end -->

    <!-- 纸质版讲义 -->
    <div class="body-common body-model-c">
      <div class="body-center">
        <!--纸质版讲义-->
        <div class="space-title" id="zzbjy">
          &gt;
          <div class="model-title">
            <h3>
              <span class="model-title-span-image">6</span>
              <strong>纸质版讲义</strong>
              <br />取证班专享赠送纸质版《教材精讲班》讲义
            </h3>
          </div>
          <br clear="all" />
        </div>

        <!--内容-->

        <div class="collection clearfix">
          <div class="collection-l fl clearfix">
            <dl class="collection-dl-left">
              <dt>
                <span>授课老师编写</span>
                <b></b>
              </dt>
              <dd>
                <span>由姜雅、仇牧、王何伟等多位授课老师编著，包邮到家</span>
              </dd>
            </dl>

            <dl class="collection-dl-left collection-jtop">
              <dt>
                <span>配套例题</span>
                <b></b>
              </dt>

              <dd>
                <span>每个知识点配套典型例题和历年真题，加深理解</span>
              </dd>
            </dl>
          </div>
          <div class="collection-button fl">
            <a @click="scroll(880)">购课赠送&gt;&gt;</a>
          </div>
          <div class="collection-l collection-jl fl clearfix">
            <dl class="collection-dl-right">
              <dt>
                <span>精华考点汇总</span>
                <b></b>
              </dt>
              <dd>
                <span>汇总各科教材精华考点、重难点知识，随时随地巩固提分</span>
              </dd>
            </dl>

            <dl class="collection-dl-right collection-jtop">
              <dt>
                <span>匹配课程内容</span>
                <b></b>
              </dt>
              <dd>
                <span>与教材精讲班内容完全匹配，建议结合课程进行学习</span>
              </dd>
            </dl>
          </div>
          <p class="sm_bz">说明：封面图供参考，以正式发布版本为准</p>
        </div>

        <!--内容 end-->

        <!--纸质版讲义  end-->

        <!--04报考选择-->
        <div class="space-title">
          <div class="model-title">
            <h3>
              <span class="model-title-span-image">7</span>
              <strong>报考选择</strong>
              <br />专业指导报考，科学选择高效拿证
            </h3>
          </div>
          <br clear="all" />
        </div>

        <div class="bkxz-all" id="bkxz">
          <div class="bkxz-title claearfix">
            <div class="bkxz-tleft">
              <p class="bkxz-all-p">
                <span class="bk-bg-common blxzt-1">就业方向</span
                >社会药店、药品企业
              </p>
              <p class="bkxz-all-p">
                <span class="bk-bg-common blxzt-1">考试难度</span>★★★★☆
              </p>
            </div>

            <div class="bkxz-tright">
              <p class="bkxz-all-p">
                <span class="bk-bg-common blxzt-2">就业方向</span
                >中药制剂、生产企业、医疗机构
              </p>
              <p class="bkxz-all-p">
                <span class="bk-bg-common blxzt-2">考试难度</span>★★★★★
              </p>
            </div>
          </div>

          <div class="bkxz-nr-all clearfix">
            <div class="bkxz-model">
              <p>
                <i class="tit-bg-left"></i>报考比例
                <i class="tit-bg-right"></i>
              </p>
              <span class="sp-img-1"></span>
            </div>

            <div class="bkxz-model">
              <p>
                <i class="tit-bg-left"></i>市场需求
                <i class="tit-bg-right"></i>
              </p>
              <span class="sp-img-2"></span>
            </div>

            <div class="bkxz-model bkxz-last-model">
              <p>
                <i class="tit-bg-left"></i>证书价值
                <i class="tit-bg-right"></i>
              </p>
              <span class="sp-img-3"></span>
            </div>
          </div>
        </div>

        <!--04报考选择 END-->

        <!--05授课体系-->

        <div class="sktx-all" id="sktx">
          <div class="clearfix">
            <div class="model-title">
              <h3>
                <span class="model-title-span-image">8</span>
                <strong>授课体系</strong>
                <br />四步取证法，轻松提分
              </h3>
            </div>
          </div>

          <div class="sktx-model-all">
            <ul class="clearfix">
              <li class="clearfix fltl-tx">
                <div class="sktx-model-l">
                  <div class="sm-l-time">
                    <i class="sktx-bg-img-common sktx-bg-img-1"></i>
                    <i class="jtic-1"></i>
                    <i class="jtic-2"></i>
                    <strong>
                      40
                      <span>%</span>
                    </strong>
                    <p>提分指数</p>
                  </div>
                </div>
                <div class="sktx-model-r">
                  <div class="smr-t">
                    <h4>教材精讲班</h4>
                    <a>
                      含金量
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                    </a>
                    <div class="sktx-learn clearfix">
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习方法</span>
                        <span class="sktx-paragraph-right"
                          >结合考试教材学习</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习效果</span>
                        <span class="sktx-paragraph-right"
                          >打好基础，锁定教材考点</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习时长</span>
                        <span class="sktx-paragraph-right">约30小时/科</span>
                      </p>
                    </div>
                  </div>
                  <div class="smr-b clearfix">
                    <h5>观全局，打好基础</h5>
                  </div>
                </div>
              </li>

              <li class="clearfix">
                <div class="sktx-model-l">
                  <div class="sm-l-time">
                    <i class="sktx-bg-img-common sktx-bg-img-2"></i>
                    <i class="jtic-1"></i>
                    <i class="jtic-2"></i>
                    <strong>
                      30
                      <span>%</span>
                    </strong>
                    <p>提分指数</p>
                  </div>
                </div>
                <div class="sktx-model-r">
                  <div class="smr-t">
                    <h4>习题班+冲刺班</h4>
                    <a>
                      含金量
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                      <i class="star-2"></i>
                    </a>
                    <div class="sktx-learn clearfix">
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习方法</span>
                        <span class="sktx-paragraph-right"
                          >做题突破，汇总重点</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习效果</span>
                        <span class="sktx-paragraph-right"
                          >掌握答题技巧和高频考点</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习时长</span>
                        <span class="sktx-paragraph-right">约10小时/科</span>
                      </p>
                    </div>
                  </div>
                  <div class="smr-b clearfix">
                    <h5>解核心，直击要点</h5>
                  </div>
                </div>
              </li>

              <li class="clearfix fltl-tx">
                <div class="sktx-model-l">
                  <div class="sm-l-time">
                    <i class="sktx-bg-img-common sktx-bg-img-3"></i>
                    <i class="jtic-1"></i>
                    <i class="jtic-2"></i>
                    <strong>
                      20
                      <span>%</span>
                    </strong>
                    <p>提分指数</p>
                  </div>
                </div>
                <div class="sktx-model-r">
                  <div class="smr-t">
                    <h4>考题突击班</h4>

                    <a>
                      含金量
                      <i></i>
                      <i></i>
                      <i></i>
                      <i class="star-2"></i>
                      <i class="star-2"></i>
                    </a>
                    <div class="sktx-learn clearfix">
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习方法</span>
                        <span class="sktx-paragraph-right"
                          >结合错题攻克关联考点</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习效果</span>
                        <span class="sktx-paragraph-right"
                          >考前自检，冲刺再提分</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习时长</span>
                        <span class="sktx-paragraph-right">约5小时/科</span>
                      </p>
                    </div>
                  </div>
                  <div class="smr-b clearfix">
                    <h5>切入点，高效突破</h5>
                  </div>
                </div>
              </li>

              <li class="clearfix">
                <div class="sktx-model-l">
                  <div class="sm-l-time">
                    <i class="sktx-bg-img-common sktx-bg-img-4"></i>
                    <i class="jtic-1"></i>
                    <i class="jtic-2"></i>
                    <strong>
                      10
                      <span>%</span>
                    </strong>
                    <p>提分指数</p>
                  </div>
                </div>
                <div class="sktx-model-r">
                  <div class="smr-t">
                    <h4>真题解析班</h4>
                    <a>
                      含金量
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                      <i class="star-2"></i>
                    </a>
                    <div class="sktx-learn clearfix">
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习方法</span>
                        <span class="sktx-paragraph-right">做真题听解析</span>
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习效果</span>
                        <span class="sktx-paragraph-right"
                          >总结历年规律，找准考点</span
                        >
                      </p>
                      <p class="sktx-learn-paragraph clearfix">
                        <span class="sktx-paragraph-left">学习时长</span>
                        <span class="sktx-paragraph-right">约10小时/科</span>
                      </p>
                    </div>
                  </div>
                  <div class="smr-b clearfix">
                    <h5>听真题，巩固练习</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!--05授课体系 END-->
      </div>
    </div>
    <!-- 纸质版讲义end -->
    <!-- 师资团队 -->
    <div class="body-common body-model-d">
      <div class="body-center">
        <!--06核心考点-->

        <div class="space-title2" id="hxkd" style="display:none;">
          <div class="model-title bdtitle-black">
            <h3>
              <span class="model-title-span-image">7</span>
              <strong>核心考点</strong>
              <br />直击核心，对症下药
            </h3>
          </div>
          <br clear="all" />
        </div>
        <div
          class="hxkd-all"
          data-type="{cs1:'curr',tlist:'.hxkd-tab-hd span',clist:'.hxkd-tab-bd'}"
          node-type="menu-tab"
          style="display:none;"
        >
          <p class="hxkd-tab-hd">
            <span class="curr hd-list01">中药一</span>
            <span class="other-bgm">中药二</span>
            <span>中药综合</span>
            <span class="other-bgm">药学一</span>
            <span>药学二</span>
            <span class="other-bgm">药学综合</span>
            <span>药事管理</span>
          </p>

          <i class="kdfx-linebg"></i>

          <div class="hxkd-tab-bd clearfix">
            <ul class="hxkd-bd-list">
              <li>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%" colspan="4">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第一章</td>
                      <td colspan="4">
                        <p>
                          中药四气、五味、毒性；七情配伍；君臣佐使组方原则；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第三章</td>
                      <td colspan="4">
                        <p>
                          中药所含化学成分的类型、名称及结构特点，化合物的生理活性、化学反应、类型一级名称；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第四章</td>
                      <td colspan="4">
                        <p>中药炮制品种与炮制品功效、辅料的总体作用、用量；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第六章</td>
                      <td colspan="4">
                        <p>各剂型辅料、添加剂；各类剂型质量标准；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第八章</td>
                      <td colspan="4">
                        <p>
                          青霉素、各类头孢菌素的作用、林可霉素；
                          氨基糖苷类药等药物的作用及不良反应；氟喹诺酮、异烟肼-利福平、深浅真菌药；
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第3章</span>
                    <strong>占比23%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:23%" class="hxkdzb-line-left"></i>
                    <i style="width:77%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第4章</span>
                    <strong>占比6%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:6%" class="hxkdzb-line-left"></i>
                    <i style="width:94%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第6章</span>
                    <strong>占比24%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:24%" class="hxkdzb-line-left"></i>
                    <i style="width:76%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第8章</span>
                    <strong>占比29%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:29%" class="hxkdzb-line-left"></i>
                    <i style="width:71%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >本科共8章，考生复习时需注意第六章中药药剂学，内容变动较大，新增的知识点，要掌握。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30123"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>

          <div class="hxkd-tab-bd clearfix" style="display: none;">
            <ul class="hxkd-bd-list">
              <li>
                <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  class="hxld-tb-1"
                >
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%" colspan="4">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">药物对比</td>
                      <td colspan="4">
                        <p>
                          1、香薷、麻黄； 2、薄荷、牛蒡子、蝉蜕；
                          3、桑叶、菊花； 4、柴胡、升麻、葛根等；
                          5、酸枣仁、柏仁子； 6、桑白皮、葶苈子；
                          7、人参、西洋参； 8、补骨脂、益智仁； 9、硫磺、雄黄；
                          10、 生地黄、玄参；
                          11、金银花、连翘；12、大青叶、板蓝根、青黛；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">解表剂</td>
                      <td colspan="4">
                        <p>
                          1、辛温解表剂；2、辛凉解表剂；3、解表胜湿挤；
                          4、祛暑解表剂；5、扶正解表剂；6、治疮伤剂；
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第1部分</span>
                    <strong>占比55%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:55%" class="hxkdzb-line-left"></i>
                    <i style="width:45%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第2部分</span>
                    <strong>占比45%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:45%" class="hxkdzb-line-left"></i>
                    <i style="width:55%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >本科分为两个部分，复习时可进行纵横向结合，横向总结根据病症的特殊性归纳，纵向总结根据病症的功效来进行归纳。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30124"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>

          <div class="hxkd-tab-bd clearfix" style="display: none;">
            <ul class="hxkd-bd-list">
              <li>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">章</td>
                      <td colspan="4">
                        <p>藏象、气血津液、病因、发病与病机；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第二章</td>
                      <td colspan="4">
                        <p>望诊、问诊、脏腑辩证；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第三章</td>
                      <td colspan="4">
                        <p>
                          治标与治本、正治与反治、扶正与祛邪、
                          调整阴阳、三因制宜；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第六章</td>
                      <td colspan="4">
                        <p>用药指导、应用药品的特殊提示；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第七章</td>
                      <td colspan="4">
                        <p>处方审核、处方调配与复核、特殊重要处方与调剂；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第八章</td>
                      <td colspan="4">
                        <p>重要的质量变异现象、重要贮藏；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第九章</td>
                      <td colspan="4">
                        <p>中西药的联合使用；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第十章</td>
                      <td colspan="4">
                        <p>老年人、肾或肝功能不全者的中药应用；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第十一章</td>
                      <td colspan="4">
                        <p>医疗用毒性重要的中毒反应；</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>1-3章讲中医</span>
                    <strong>占比50%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:50%" class="hxkdzb-line-left"></i>
                    <i style="width:50%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>4-6章讲中药</span>
                    <strong>占比19%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:19%" class="hxkdzb-line-left"></i>
                    <i style="width:81%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>7-11章讲其他</span>
                    <strong>占比31%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:31%" class="hxkdzb-line-left"></i>
                    <i style="width:69%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >教材共分11个章节，复习原则：狠抓第1-3、7、9高分章节；第6、8章，第10-11章低分但易得分；第4-5章内容多，但分值不高，不需花很多时间。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30125"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>

          <div class="hxkd-tab-bd clearfix" style="display: none;">
            <ul class="hxkd-bd-list">
              <li>
                &lt;
                <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  class="hxld-tb-2"
                >
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%" colspan="4">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第一章</td>
                      <td>
                        <p>药物的来源于分类、药物命名；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第二章</td>
                      <td colspan="4">
                        <p>典型官能团对药物活性的影响、生物转化；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第三章</td>
                      <td colspan="4">
                        <p>
                          固体制剂的分类、材料及功效、液体制剂的溶剂和附加剂；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第五章</td>
                      <td colspan="4">
                        <p>缓释、控释制剂的分类及原理、特点等；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第七章</td>
                      <td colspan="4">
                        <p>
                          药物的治疗作用、量反应与质反应、效量曲线的几个基本概念、药动学的相互作用；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第十一章</td>
                      <td colspan="4">
                        <p>
                          镇静与催眠药、非苯二氮卓类药、解热镇痛药、抗炎药、高血压药；
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第1-3-11章</span>
                    <strong>占比50%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:50%" class="hxkdzb-line-left"></i>
                    <i style="width:50%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第2章</span>
                    <strong>占比8%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:8%" class="hxkdzb-line-left"></i>
                    <i style="width:92%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第5章</span>
                    <strong>占比7%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:7%" class="hxkdzb-line-left"></i>
                    <i style="width:93%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第7章</span>
                    <strong>占比15%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:15%" class="hxkdzb-line-left"></i>
                    <i style="width:85%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >本科共11章，除章节外，其他章节分值分配均匀；考试难度在于药物的化学结构。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30127"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>

          <div class="hxkd-tab-bd clearfix" style="display: none;">
            <ul class="hxkd-bd-list">
              <li>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">章</td>
                      <td colspan="4">
                        <p>
                          苯二氮卓类的作用特点、临床应用、不良反应；癫痫用药的选择、镇痛药、吗啡；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第二章</td>
                      <td colspan="4">
                        <p>
                          解热、镇痛、抗炎药的作用机制；秋水仙碱、别嘌醇及丙磺舒的作用特点；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第三章</td>
                      <td colspan="4">
                        <p>
                          右美沙芬、β2受体激动剂、氨茶碱、吸入性糖皮质激素、药物的相互作用；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第四章</td>
                      <td colspan="4">
                        <p>
                          抗酸剂与抑酸剂、铋剂、阿托品、甲痒氯普胺-托潘立酮-莫沙必利；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第五章</td>
                      <td colspan="4">
                        <p>强心苷、胺碘酮、硝酸甘油、抗高血压药；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第十章</td>
                      <td colspan="4">
                        <p>
                          青霉素、各类头孢菌素的作用、林可霉素；
                          氨基糖苷类药等药物的作用及不良反应；氟喹诺酮、异烟肼-利福平、深浅真菌药；
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第1-3章</span>
                    <strong>占比16%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:16%" class="hxkdzb-line-left"></i>
                    <i style="width:84%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第4章</span>
                    <strong>占比9%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:9%" class="hxkdzb-line-left"></i>
                    <i style="width:91%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第5章</span>
                    <strong>占比14%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:14%" class="hxkdzb-line-left"></i>
                    <i style="width:86%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第10章</span>
                    <strong>占比21%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:21%" class="hxkdzb-line-left"></i>
                    <i style="width:79%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >本科共16章，除章节外，其余章节考分比值相差不大。考生需记忆各类药物之间的反应，特别是第5章考试频率高，考生须着重掌握。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30128"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>

          <div class="hxkd-tab-bd clearfix" style="display: none;">
            <ul class="hxkd-bd-list">
              <li>
                <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  class="hxld-tb-3"
                >
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第二章</td>
                      <td colspan="4">
                        <p>
                          药物配伍禁忌、重复用药、药物贮存、药学计算；常用外文缩写、特殊药品管理；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第三章</td>
                      <td colspan="4">
                        <p>药物信息咨询、常用药品服用时间及主要事项；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第四章</td>
                      <td colspan="4">
                        <p>
                          用药与因果关系、特殊药物导致的药源性疾病、合理用药指导、特殊人群用药注意事项、药品质量缺陷，药品不良反应；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第八章</td>
                      <td colspan="4">
                        <p>常见病症药物治疗的禁忌症与注意事项；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第十章</td>
                      <td colspan="4">
                        <p>
                          高血压、冠心病、房颤、高血脂等疾病的药物治疗及注意事项；常见药物服用时间；
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第2章</span>
                    <strong>占比15%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:15%" class="hxkdzb-line-left"></i>
                    <i style="width:85%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第3章</span>
                    <strong>占比11%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:11%" class="hxkdzb-line-left"></i>
                    <i style="width:89%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第4章</span>
                    <strong>占比17%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:17%" class="hxkdzb-line-left"></i>
                    <i style="width:83%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第8章</span>
                    <strong>占比20%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:20%" class="hxkdzb-line-left"></i>
                    <i style="width:80%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第10章</span>
                    <strong>占比9%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:9%" class="hxkdzb-line-left"></i>
                    <i style="width:91%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >本科共20个章节，除章节外，其余章之间分值占比差距悬殊，第7、9章分值较低，属于次章节，其它章节分值均在3分左右，不必花太多时间。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30129"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>

          <div class="hxkd-tab-bd clearfix" style="display: none;">
            <ul class="hxkd-bd-list">
              <li>
                <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  class="hxld-tb-4"
                >
                  <tbody>
                    <tr>
                      <th width="10%"></th>
                      <th width="30%">核心考点</th>
                    </tr>
                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第四章</td>
                      <td colspan="4">
                        <p>GSP药品批发的质量管理（采购、验收、储存与养护）；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第五章</td>
                      <td colspan="4">
                        <p>
                          GSP药品零售的质量管理（陈列、销售）；处方开具、调剂和审核；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第七章</td>
                      <td colspan="4">
                        <p>药品说明书格式和书写要求的基本内容；</p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第九章</td>
                      <td colspan="4">
                        <p>
                          医疗机构制剂的特征及调剂使用；处方保存期及销毁程序；执业药师注册管理；
                        </p>
                      </td>
                    </tr>

                    <tr class="kdfx-nr-tr">
                      <td class="kdfx-star">第十章</td>
                      <td colspan="4">
                        <p>药品经营许可证的管理；行政处罚的决定及程序；</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ul>

            <div class="hxkd-right">
              <h5>
                <i class="hxkd-title-icon1"></i>复习攻略
                <i class="hxkd-title-icon2"></i>
              </h5>
              <p class="hxkd-right-p">章节分值比例</p>

              <ul>
                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第4章</span>
                    <strong>占比9%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:9%" class="hxkdzb-line-left"></i>
                    <i style="width:91%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第5章</span>
                    <strong>占比31%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:31%" class="hxkdzb-line-left"></i>
                    <i style="width:69%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第7章</span>
                    <strong>占比11%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:11%" class="hxkdzb-line-left"></i>
                    <i style="width:89%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第9章</span>
                    <strong>占比7%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:7%" class="hxkdzb-line-left"></i>
                    <i style="width:93%" class="hxkdzb-line-right"></i>
                  </div>
                </li>

                <li>
                  <div class="hxkd-zb-1 clearfix">
                    <span>第10章</span>
                    <strong>占比13%</strong>
                  </div>

                  <div class="hxkd-zb-2 clearfix">
                    <i style="width:13%" class="hxkdzb-line-left"></i>
                    <i style="width:87%" class="hxkdzb-line-right"></i>
                  </div>
                </li>
              </ul>

              <font
                >本科共11章，其中第5、7、10三章考点多，难度较大，第5章尤其重要，占三分之一；时间紧迫时只需拿下第3-7章、第9-10章内容，以此通过考试。</font
              >
              <a
                href="//wx.233.com/search/v1/study/?mid=30130"
                class="hxkd-btn"
                target="_blank"
              >
                <b>更多考点</b>
              </a>
            </div>
          </div>
        </div>

        <!--06核心考点END-->

        <!--07老师-->

        <div class="space-title1" id="sztd">
          <div class="model-title bdtitle-black">
            <h3>
              <span class="model-title-span-image">9</span>
              <strong>师资团队</strong>
              <br />集结业内师资，助力快速提分
            </h3>
          </div>
          <br clear="all" />
        </div>

        <div
          class="careerbox"
          id="js-teacher-main"
          data-type="{img:'.teacher-cl',left:'.T-btn-left',right:'.T-btn-right',nav:'.teacher-team li','cs':'action','effect':'0','auto':false}"
          node-type="menu-slide"
        >
          <div class="teacher-cl" data-act="刘丹" v-show="teacherTeamCur === 0">
            <div class="teacher-cl-left">
              <img
                src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-8.png"
              />
            </div>
            <div class="teacher-cl-right">
              <ul>
                <li>
                  <strong>刘丹</strong>
                  <span class="teacher-jl">[ 教龄4年 ]</span>
                </li>

                <li>
                  <h4 class="teacher-title2">医学硕士，任职于北京某医院</h4>
                </li>
                <li>
                  <p><em>主讲</em>《西药学-综合知识与技能》</p>
                  <p><em>特色</em>拥有丰富的教学经验、深谙考试规律。</p>
                  <p>
                    <em>风格</em
                    >锁定核心考点，引领考生避开备考误区，大受学员好评。
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div class="teacher-cl" data-act="仇牧" v-show="teacherTeamCur === 1">
            <div class="teacher-cl-left">
              <img
                src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-3.png"
              />
            </div>
            <div class="teacher-cl-right">
              <ul>
                <li>
                  <strong>仇牧</strong>
                  <span class="teacher-jl">[ 教龄4年 ]</span>

                  <a
                    href="javascript:;"
                    data-type="{'teacherId':'972','title':'仇牧'}"
                    node-type="menu-wx-popup-kc"
                    class="teacher-btn"
                  >
                    <b>点击试听课程</b>
                  </a>
                </li>

                <li>
                  <h4 class="teacher-title2">北京著名医学院校教授</h4>
                </li>
                <li>
                  <p><em>主讲</em>《药学专业知识（一）》</p>
                  <p><em>特色</em>善于自编考点口诀，快速记忆复杂内容。</p>
                  <p>
                    <em>风格</em
                    >专业功底扎实，教学经验丰富。讲课思路清晰，分明，深受学员好评。
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="teacher-cl"
            data-act="王何伟"
            v-show="teacherTeamCur === 2"
          >
            <div class="teacher-cl-left">
              <img
                src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-7.png"
              />
            </div>
            <div class="teacher-cl-right">
              <ul>
                <li>
                  <strong>王何伟</strong>
                  <span class="teacher-jl">[ 教龄10年 ]</span>

                  <a href="javascript:;" class="teacher-btn">
                    <b>老师课程敬请期待</b>
                  </a>
                </li>

                <li>
                  <h4 class="teacher-title2">国内知名大学临床医学专业</h4>
                </li>
                <li>
                  <p><em>主讲</em>《药学专业知识（二）》</p>
                  <p><em>特色</em>独特的授课思路及方式，使其讲解通俗易懂。</p>
                  <p><em>风格</em>对考试考题方向把握极为准确，深受学员好评。</p>
                </li>
              </ul>
            </div>
          </div>

          <div class="teacher-cl" data-act="姜雅" v-show="teacherTeamCur === 3">
            <div class="teacher-cl-left">
              <img
                src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-2.png"
              />
            </div>
            <div class="teacher-cl-right">
              <ul>
                <li>
                  <strong>姜雅</strong>
                  <span class="teacher-jl">[ 教龄9年 ]</span>
                </li>

                <li>
                  <h4 class="teacher-title2">
                    清华大学医学部博士毕业，现为协和医学院副教授
                  </h4>
                </li>
                <li>
                  <p><em>主讲</em>《中药学专业知识（一）》</p>
                  <p><em>特色</em>独特的教学主张，讲课娓娓道来。</p>
                  <p>
                    <em>风格</em
                    >从事药物及其相关专业学习和研究十多年，幽默风趣。
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="teacher-cl"
            data-act="刘恩钊"
            v-show="teacherTeamCur === 4"
          >
            <div class="teacher-cl-left">
              <img
                src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-6.png"
              />
            </div>
            <div class="teacher-cl-right">
              <ul>
                <li>
                  <strong>刘恩钊</strong>
                  <span class="teacher-jl">[ 教龄8年 ]</span>
                </li>

                <li>
                  <h4 class="teacher-title2">北京某高校教师，医学硕士</h4>
                </li>
                <li>
                  <p><em>主讲</em>《中药学-综合知识与技能》</p>
                  <p><em>特色</em>善于总结归纳，讲解突出。</p>
                  <p>
                    <em>风格</em
                    >教学经验丰富，化繁为简，通俗易懂，举一反三，被广大考生交口称赞。
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="teacher-cl"
            data-act="解婷婷"
            v-show="teacherTeamCur === 5"
          >
            <div class="teacher-cl-left">
              <img
                src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-9.png"
              />
            </div>
            <div class="teacher-cl-right">
              <ul>
                <li>
                  <strong>解婷婷</strong>
                  <span class="teacher-jl">[ 教龄6年 ]</span>
                </li>

                <li>
                  <h4 class="teacher-title2">国内知名中医药大学硕士</h4>
                </li>
                <li>
                  <p><em>主讲</em>《中药学专业知识（二）》</p>
                  <p><em>特色</em>深知考题精髓，了解学员复习瓶颈所在。</p>
                  <p>
                    <em>风格</em
                    >将枯燥的理论知识通俗化、趣味化、简洁化，打通考证大门。
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div class="teacher-team">
            <i class="teacher-team-bg"></i>
            <i class="teacher-team-bg2"></i>
            <ul>
              <a
                class="T-btn-left"
                @click="
                  teacherTeamCur = teacherTeamCur > 0 ? teacherTeamCur - 1 : 0
                "
              ></a>
              <a
                class="T-btn-right"
                @click="
                  teacherTeamCur = teacherTeamCur < 5 ? teacherTeamCur + 1 : 5
                "
              ></a>

              <li
                data-act="丁凡"
                :class="teacherTeamCur === 0 ? 'action' : ''"
                @click="teacherTeamCur = 0"
              >
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-8-1.jpg"
                />
              </li>

              <li
                data-act="仇牧"
                :class="teacherTeamCur === 1 ? 'action' : ''"
                @click="teacherTeamCur = 1"
              >
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-3-1.jpg"
                />
              </li>

              <li
                data-act="王何伟"
                :class="teacherTeamCur === 2 ? 'action' : ''"
                @click="teacherTeamCur = 2"
              >
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-7-1.jpg"
                />
              </li>

              <li
                data-act="姜雅"
                :class="teacherTeamCur === 3 ? 'action' : ''"
                @click="teacherTeamCur = 3"
              >
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-2-1.jpg"
                />
              </li>

              <li
                data-act="刘恩钊"
                :class="teacherTeamCur === 4 ? 'action' : ''"
                @click="teacherTeamCur = 4"
              >
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-6-1.jpg"
                />
              </li>
              <li
                data-act="解婷婷"
                :class="teacherTeamCur === 5 ? 'action' : ''"
                @click="teacherTeamCur = 5"
              >
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/teacher-9-1.jpg"
                />
              </li>
            </ul>
          </div>
        </div>

        <!--07老师END-->
      </div>
    </div>
    <!-- 师资团队end -->

    <!-- 在线题库 -->
    <div class="body-common body-model-e">
      <div class="body-center">
        <!--09在线题库-->

        <div class="zztk-all" id="zxtk">
          <div class="space-title">
            <div class="model-title">
              <h3>
                <span class="model-title-span-even">10</span>
                <strong>在线题库</strong>
                <br />多做题，巩固知识点
              </h3>
            </div>
            <div class="clearfix"></div>
          </div>

          <div
            class="question-bank"
            data-type="{cs1: 'current',tlist: '.question-plist .question',clist: '.question-qie'}"
            node-type="menu-tab"
          >
            <ul class="question-plist">
              <li
                :class="['question', zztkCur === index ? 'current' : '']"
                v-for="(item, index) in [
                  '全真模拟',
                  '章节练习',
                  '历年真题',
                  '错题记录',
                ]"
                :key="index"
                @click="zztkCur = index"
              >
                <em :class="'question-tu' + parseInt(index + 1)"></em>
                <i>{{ item }}</i>
                <b></b>
              </li>
            </ul>
            <div class="question-qie" v-show="zztkCur === 0">
              <p class="zxtk-text">全真模拟试卷，提前演练。</p>
              <em>
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/tk01.png"
                />
              </em>
              <a class="questionaa" @click="djzt">点击做题</a>
            </div>
            <div class="question-qie" v-show="zztkCur === 1">
              <p class="zxtk-text">
                以高频考点为核心，锁定教材各章核心知识点。
              </p>
              <em>
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/tk02.png"
                />
              </em>
              <a
                href="//wx.233.com/tiku/chapter/217"
                class="questionaa"
                target="_blank"
                >免费做题</a
              >
            </div>
            <div class="question-qie" v-show="zztkCur === 2">
              <p class="zxtk-text">
                收录中医/西医近3年真题试卷，拿下高频考点。
              </p>
              <em>
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/tk03.png"
                />
              </em>
              <a
                href="//wx.233.com/tiku/exam/217-2-0-0-1"
                class="questionaa"
                target="_blank"
                >免费做题</a
              >
            </div>
            <div class="question-qie" v-show="zztkCur === 3">
              <p class="zxtk-text">
                智能汇总所有错题，锁定不会的题，猛补知识盲点。
              </p>
              <em>
                <img
                  src="http://img2.233.com/wx/union/pc/fine/category/img/yaoshi/tk04.png"
                />
              </em>
              <a
                href="//wx.233.com/tiku/err/217"
                class="questionaa"
                target="_blank"
                >免费做题</a
              >
            </div>
          </div>
        </div>

        <!--09在线题库 END-->
      </div>
    </div>
    <!-- 在线题库end -->

    <!--06套用官网内容  end------------->
    <!--05服务特色标题-->
    <div class="main-title f-tac m-b-30 p-t-50">
      <p class="font-bg">CHARACTERISTIC</p>
      <h2 class="font44 fb">
        选择我们的
        <em class="text-red fb">四大理由</em>
      </h2>
      <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
    </div>
    <div class="fuwu-bg">
      <div class="fuwu-content">
        <div class="fuwu-box">
          <ul class="clearfix m-b-20">
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">1</span>课程品质高
              </h4>
              <p class="font15 lh2 p-15">
                课程专业的教研团队精心打造，
                <em class="text-red fb">每个课程均经过20+次以上迭代</em>。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">2</span>老师实力强
              </h4>
              <p class="font15 lh2 p-15">
                网校执行严格的
                <em class="text-red fb">师资淘汰制，由购课学员评分</em
                >，努力建设零差评老师团队。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">3</span>学习服务优
              </h4>
              <p class="font15 lh2 p-15">
                您在学习课程中遇到任何问题，可在线提问，专业老师
                <em class="text-red fb">24小时内为您答疑解惑</em>。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">4</span>售后服务好
              </h4>
              <p class="font15 lh2 p-15">
                部分套餐课程享
                <em class="text-red fb">超长有效期</em>，课程有效期内考试
                <em class="text-red fb">不过免费重学</em>保障。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--05服务特色 end-->

    <!--10新人优惠券-->
    <div class="z-swimnavb" style=" display:none;">
      <div class="z-main z-xxhl clearfix">
        <div class="z-thjj clearfix">
          <div class="z-jjpople"></div>
          <div class="z-bmth">
            <span>注册报名限时特惠</span>
          </div>
        </div>
        <ul class="z-yhqpy clearfix">
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money"> <i>￥</i>150 </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满1200可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money"> <i>￥</i>60 </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满600可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money"> <i>￥</i>30 </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满400可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money"> <i>￥</i>10 </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满200可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
        </ul>
        <div class="z-cha"></div>
      </div>
    </div>
    <!--10新人优惠券 end-->
  </div>
</template>
<script>
import myvideo from "@/components/myvideo";
import banjiduibi from "@/components/banjiduibi";
import quanbubanji from "@/components/quanbubanji";
import { getMemberPicpath } from "@/request/request.js";
export default {
  name: "App",
  components: {
    banjiduibi,
    quanbubanji,
    myvideo,
  },
  data() {
    return {
      laoshiindex: 0,
      isLogin: false,
      logoSrc: "",
      allLoginPlayFlag: false,
      unionId: "",
      kefu: "",
      logo: "",
      href: "",
      courses: [
        { name: "药学专业知识(一)", myClassId: 30127 },
        { name: "药学专业知识(二)", myClassId: 30128 },
        { name: "中药学专业知识(一)", myClassId: 30123 },
        { name: "中药学专业知识(二)", myClassId: 30124 },
        { name: "药学综合知识与技能", myClassId: 30129 },
        { name: "中药学综合知识与技能", myClassId: 30125 },
        { name: "药事管理与法规", myClassId: 30130 },
        { name: "药事管理与法规(中药)", myClassId: 30126 },
      ],
      courseIndex: 0,
      isHoverCourse: false,
      zztkCur: 0,
      teacherTeamCur: 0,
    };
  },
  created() {
    this.href = encodeURIComponent(window.location.href);
    var config = JSON.parse(
      sessionStorage.getItem(window.location.host + "puconfig")
    );
    if (config.KefuTelList.length > 0) {
      this.kefu = config.KefuTelList[0].KefuNumber;
    }
    this.unionId = config.UnionId;
    this.logo = config.UnionLogo;
    this.allLoginPlayFlag = config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if (token != undefined) {
      this.isLogin = true;
      getMemberPicpath({}, (res) => {
        this.logoSrc = res;
      });
    } else {
      var interval = setInterval(() => {
        token = localStorage.getItem("usertoken");
        if (token != undefined) {
          this.isLogin = true;
          getMemberPicpath({}, (res) => {
            this.logoSrc = res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods: {
    loginout() {
      this.isLogin = false;
      this.logoSrc = "";
      localStorage.removeItem("usertoken");
    },
    scroll(num) {
      document.documentElement.scrollTop = num;
    },
    changeCourseIndex(i) {
      this.courseIndex = i;
    },
    changeIsHoverCourse(flag) {
      this.isHoverCourse = flag;
    },
    changehoverindex(i) {
      this.hoverindex = i;
    },
    changelaoshiindex(i) {
      this.laoshiindex = i;
    },
    djzt() {
      window.open("/tiku/exam/class?redirect=" + location.href);
    },
  },
};
</script>
